import { INumberRangeAlertBehavior } from "../../../../documaker/domain/format/objects";
import { IPropertyEditable, instanceOfIPropertyEditable } from "../../../../base/domain/system/edit";

export interface INumberRangeAlertBehaviorPropertyEditable {
  numberRangeAlertBehavior(): IPropertyEditable<INumberRangeAlertBehavior>;
}

export function instanceOfINumberRangeAlertBehaviorPropertyEditable(instance: any): instance is INumberRangeAlertBehaviorPropertyEditable {
  return instance
      && instance.numberRangeAlertBehavior
      && instanceOfIPropertyEditable<INumberRangeAlertBehavior>(instance.numberRangeAlertBehavior());
}
